import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_brand_values: FaireCategoryEntity = {
  token: "cat_brand-values",
  type: "category",
  name: "Brand values",
  level: 1,
  href: "/category/brand-values",
  childCategoryTokens: [
    "cat_brand-values-all",
    "cat_brand-values-new-products",
    "cat_brand-values-new-brands",
    "cat_brand-values-bestsellers",
    "cat_brand-values-sustainable",
    "cat_brand-values-local",
    "cat_brand-values-women-owned",
    "cat_brand-values-b-corp",
  ],
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
